<template>
	<div>
		<AppVMenu
			left
			bottom
			rounded="lg"
			v-bind="$attrs"
			min-width="404"
			max-width="404"
			v-on="$listeners"
			:nudge-bottom="15"
			v-model="showMenu"
			:close-on-content-click="false"
			transition="slide-y-transition"
			content-class="publish-errors-dropdown-menu"
		>
			<template v-slot:activator="activator">
				<div @click="onActivatorClick">
					<slot name="activator" v-bind:activator="activator" v-bind:isOpen="showMenu" />
				</div>
			</template>
			<Col class="menu-container">
				<slot name="content">
					<PublishErrorsDropdownContent
						@close="closeMenu"
						:arrowLeft="arrowLeft"
						:nameOfAction="nameOfAction"
						v-if="problematicNodes?.length > 0"
						:problematicNodes="problematicNodes"
					/>
					<PublishDropdownConfigurationContent :runTestBeforePublish.sync="runTestBeforePublish" v-else />
				</slot>
				<Col class="footer-container flex-centerize mx-4">
					<AppTooltip position="top" text="Fix the above issues to publish" :disabled="!showWarningIcon">
						<AnemicButton @click="startPublish" class="pa-0 publish-button" tile :disabled="showWarningIcon">
							{{ publishButtonText }}
							<SIcon
								:width="12"
								:height="12"
								class="ml-1"
								v-if="showWarningIcon"
								:name="warningIconReverted ? 'publish-warning-reverted' : 'publish-warning'"
							/>
						</AnemicButton>
					</AppTooltip>
				</Col>
			</Col>
		</AppVMenu>
	</div>
</template>
<script>
import PublishErrorsDropdownContent from '@/components/Project/PublishButtonDropdown/PublishErrorsDropdownContent.vue';
import PublishDropdownConfigurationContent from '@/components/Project/PublishButtonDropdown/PublishDropdownConfigurationContent.vue';

export default {
	name: 'PublishButtonDropdown',
	components: {
		PublishErrorsDropdownContent,
		PublishDropdownConfigurationContent,
	},
	props: {
		problematicNodes: { type: Array },
		showWarningIcon: { type: Boolean },
		arrowLeft: { type: [Number, String] },
		warningIconReverted: { type: Boolean },
		nameOfAction: { type: String, required: true },
	},
	computed: {
		publishButtonText() {
			return this.runTestBeforePublish ? 'Test run and Publish' : 'Publish';
		},
	},
	methods: {
		openMenu() {
			this.showMenu = true;
		},
		closeMenu() {
			this.showMenu = false;
		},
		onActivatorClick(e) {
			this.openMenu();
			e.stopPropagation();
		},
		startPublish() {
			this.closeMenu();
			this.$emit('publish-flow', { runTestBeforePublish: this.runTestBeforePublish });
		},
	},
	data() {
		return {
			showMenu: false,
			runTestBeforePublish: false,
		};
	},
};
</script>
<style scoped lang="scss">
.menu-container {
	border-radius: 8px;
	background: var(--white);
	border: 1px solid #dfe4ef;
	box-shadow: 0px 3px 16px #00000039;
}
.footer-container {
	min-height: 72px;
	border-top: 1px solid rgba(214, 221, 234, 0.26);
}
.publish-button {
	width: 286px !important;
	height: 35px !important;
	font-size: 14px !important;
	border-radius: 10px !important;
	color: var(--white) !important;
	text-transform: none !important;
	background: transparent linear-gradient(97deg, #189bf9 0%, #5b5be7 100%) !important;
	&:disabled {
		opacity: 0.4 !important;
		color: var(--white) !important;
	}
}
</style>
